import React from 'react';
import { Loading } from '../common/LoadingComponent';
import { Smartphone, Mail, CalendarDays, ShieldCheck } from '../../icons';

function getAge(dateStr) {
    const birth = new Date(dateStr);
    const today = new Date();
    let age     = today.getFullYear() - birth.getFullYear();
    const m     = today.getMonth() - birth.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;
    return age;
}

function UserCard({ user }) {
    const sinceStr = new Intl.DateTimeFormat('fr-FR', { year: 'numeric', month: 'long' }).format(user.dateCreation);

    return (
        <div style={{ background: 'white', borderRadius: 'var(--radius-xl)', boxShadow: 'var(--shadow)', border: '1px solid var(--border)', overflow: 'hidden', marginTop: 16 }}>

            {/* Header */}
            <div style={{ background: 'linear-gradient(135deg, var(--dark) 0%, #0a4a7a 100%)', padding: '36px 24px 24px', textAlign: 'center' }}>
                <img src="/assets/images/profil.svg" alt={user.firstName}
                    style={{ width: 80, height: 80, borderRadius: '50%', border: '3px solid rgba(255,255,255,0.3)', marginBottom: 14 }} />
                <h3 style={{ color: 'white', fontWeight: 800, fontSize: '1.3rem', margin: 0 }}>
                    {user.firstName} {user.lastName}
                </h3>
                <p style={{ color: 'rgba(255,255,255,0.65)', fontSize: '0.88rem', margin: '6px 0 0' }}>
                    {getAge(new Intl.DateTimeFormat('en-US').format(user.birthDate))} ans
                </p>
            </div>

            {/* Info */}
            <div style={{ padding: '24px 28px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                    <ShieldCheck size={14} strokeWidth={2} color="var(--primary)" />
                    <span style={{ fontSize: '0.78rem', color: 'var(--gray)', textTransform: 'uppercase', letterSpacing: '0.06em', fontWeight: 700 }}>
                        Membre vérifié
                    </span>
                </div>

                <div style={{ height: 1, background: 'var(--border)', margin: '16px 0' }}></div>

                {user.numberMobile && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 }}>
                        <div style={{ width: 36, height: 36, borderRadius: 10, background: 'var(--primary-light)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Smartphone size={18} strokeWidth={1.8} color="var(--primary)" />
                        </div>
                        <div>
                            <div style={{ fontSize: '0.75rem', color: 'var(--gray-light)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Téléphone</div>
                            <div style={{ fontSize: '0.95rem', color: 'var(--dark)', fontWeight: 500 }}>{user.numberMobile}</div>
                        </div>
                    </div>
                )}

                {user.email && user.email.includes('@') && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 }}>
                        <div style={{ width: 36, height: 36, borderRadius: 10, background: 'var(--primary-light)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Mail size={18} strokeWidth={1.8} color="var(--primary)" />
                        </div>
                        <div>
                            <div style={{ fontSize: '0.75rem', color: 'var(--gray-light)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em' }}>E-mail</div>
                            <div style={{ fontSize: '0.95rem', color: 'var(--dark)', fontWeight: 500 }}>{user.email}</div>
                        </div>
                    </div>
                )}

                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <div style={{ width: 36, height: 36, borderRadius: 10, background: 'var(--bg-light)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <CalendarDays size={18} strokeWidth={1.8} color="var(--gray)" />
                    </div>
                    <div>
                        <div style={{ fontSize: '0.75rem', color: 'var(--gray-light)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Membre depuis</div>
                        <div style={{ fontSize: '0.95rem', color: 'var(--dark)', fontWeight: 500 }}>{sinceStr}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const UserProfil = (props) => {
    if (props.isLoading !== false) {
        return <div className="container text-center" style={{ padding: '80px 0' }}><Loading /></div>;
    }

    const user = props.userProfile?.user || props.userProfileFromMessages?.user;

    if (!user) {
        return <div className="container text-center" style={{ padding: '80px 0' }}><h4>Profil introuvable</h4></div>;
    }

    return (
        <div className="list-page">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-7 col-lg-5">
                        <UserCard user={user} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserProfil;
